export default __webpack_public_path__ + "static/media/HalfStar.8877a933.svg";